import useTranslation from "next-translate/useTranslation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
type Props = {
  minDate: Date;
  maxDate: Date;
  onChange: (date: Date) => void;
  startDate: Date;
  placeholder?: string;
  className?: string;
  defVal?: Date;
  sm?: boolean;
  inputClassName?: string;

} & React.ComponentProps<typeof DatePicker>;
const CustomDatePicker = (
  {
    minDate,
    maxDate,
    onChange,
    startDate,
    placeholder,
    className,
    defVal,
    sm,
    inputClassName,
    ...props
  }: Props
  
) => {
  const { t } = useTranslation("common");

  return (
    <StyledDatePicker className={className ? className : ""} sm={sm}>
      <DatePicker
        showPopperArrow={false}
        selected={startDate}
        minDate={minDate}
        maxDate={maxDate}
        onChange={onChange}
        {...props}
        customInput={
          <input
            defaultValue={defVal?.toString()}
            className={`form-control ${inputClassName || ""}`}
            value={startDate?.toString()}
            placeholder={placeholder ? placeholder : t(`choose_date`)}
          />
        }
      />
    </StyledDatePicker>
  );
};

export default CustomDatePicker;
const StyledDatePicker = styled.div<{ sm: boolean }>`
  .react-datepicker {
    font-size: ${({ sm }) => (sm ? "0.85rem" : "1em")};
  }
`;
